<template>
  <div class="p-markers">
    <btn-back
      v-if="isMobile"
      :label="$t('msg.toOther')"
      :to="{name: 'other'}"
    ></btn-back>
    <card
      :show-header="false"
      class="card_max-xs"
    >
      <highlighting-tags></highlighting-tags>
    </card>
  </div>
</template>

<script>
import HighlightingTags from "@/components/block/Profile/HighlightingTags/HighlightingTags";
import BtnBack from "@/components/ui/BtnBack";

export default {
  components: {HighlightingTags, BtnBack},
}
</script>